import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import { FiHeadphones , FiMail , FiMapPin } from "react-icons/fi";
import GoogleMapReact from 'google-map-react';
import ContactTwo from "../elements/contact/ContactTwo";
import BrandTwo from "../elements/BrandTwo";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import { LanguageContext } from '../context/LanguageContext';
import translations from '../translations';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

class Contact extends Component{
    static contextType = LanguageContext;
    static defaultProps = {
        center: {
            // lat: 31.748924,
            // lng: 35.2038452
            lat:31.744822285213388,
            lng:35.207857689441305
        },
        zoom: 12
    };

    render(){
        const { language } = this.context;
        const t = translations[language];

        return(
            <React.Fragment>
                <PageHelmet pageTitle={t.contact.pageTitle} />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                 {/* Start Breadcrump Area */}
                 <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--17"  data-black-overlay="6">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">{t.contact.breadcrumb.title}</h2>
                                    <p>{t.contact.breadcrumb.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}


                {/* Start Contact Top Area  */}
                <div className="rn-contact-top-area ptb--120 bg_color--5">
                    <div className="container">

                        <div className="row">
                            {/* Start Single Address  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiHeadphones />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">{t.contact.info.phone.title}</h4>
                                        <p><a href="tel:+972 2 623 1666">+972.2.623.1666</a></p>
                                        <p><a href="tel:+972 54 543 1666">+972.54.543.1666</a></p>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Address  */}

                            {/* Start Single Address  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt_mobile--50">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMail />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">{t.contact.info.email.title}</h4>
                                        <p><a href="mailto:mass.dev100@gmail.com">mass.dev100@gmail.com</a></p>
                                        <p><a href="mailto:massDevle@massarwe.com">massDevle@massarwe.com</a></p>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Address  */}

                            {/* Start Single Address  */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt_md--50 mt_sm--50">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMapPin />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">{t.contact.info.location.title}</h4>
                                        <p>{t.contact.info.location.address} <br /> POBX 11653 Zip 9111601</p>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Address  */}

                        </div>
                    </div>
                </div>
                {/* End Contact Top Area  */}

                {/* Start Contact Page Area  */}
                <div className="rn-contact-page ptb--120 bg_color--1">
                    <ContactTwo />
                </div>
                {/* End Contact Page Area  */}

                {/* Start Contact Map  */}
                <div className="rn-contact-map-area position-relative">
                <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11412.630663501715!2d35.199988359866886!3d31.743326625789177!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1502d7fba2bfb303%3A0xc02ec39977c93d08!2sAl-Qal&#39;a%2C%20Jerusalem!5e0!3m2!1sen!2sil!4v1690285811454!5m2!1sen!2sil"  style={{ border: 0 ,  height: '650px', width: '100%'}} allowFullScreen />

                    {/* <div style={{ height: '650px', width: '100%' }}>

                        <GoogleMapReact
                            bootstrapURLKeys={{ key: "" }}
                        defaultCenter={this.props.center}
                        defaultZoom={this.props.zoom}
                        >
                        <AnyReactComponent
                            lat={31.744822285213388}
                            lng={35.207857689441305}
                            text="MassDev"
                        />
                        
                        </GoogleMapReact>
                    </div> */}
                </div>
                {/* End Contact Map  */}
                

                {/* Start Brand Area */}
                <div className="rn-brand-area brand-separation ptb--120">
                    <div className="container">
                        <div className="row">
                            {/* <div className="col-lg-12">
                                <BrandTwo />
                            </div> */}
                        </div>
                    </div>
                </div>
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />
                
            </React.Fragment>
        )
    }
}
export default Contact